import { NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import logo from "../assets/logo.png";
import "../assets/navbar.css";

function Navbar() {

    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? "hidden" : "auto";

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [menuOpen]);

    return (
        <header className="navbar">
            <div className="nav-container">

                <div className="nav-left">
                    <NavLink to="/">
                        <img src={logo} alt="Sibora Global" className="logo" />
                    </NavLink>
                    {/* <img src={logo} alt="Sibora Global" className="logo" /> */}
                </div>

                {/* HAMBURGER */}
                <div className="hamburger" onClick={() => setMenuOpen(true)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                {/* MOBILE MENU */}
                <nav className={`mobile-menu ${menuOpen ? "active" : ""}`}>

                    <div
                        className="close-menu"
                        onClick={() => setMenuOpen(false)}
                    >
                        ✕
                    </div>

                    <NavLink onClick={() => setMenuOpen(false)} to="/">Home</NavLink>
                    <NavLink onClick={() => setMenuOpen(false)} to="/about">About</NavLink>
                    <NavLink onClick={() => setMenuOpen(false)} to="/services">Services</NavLink>
                    <NavLink onClick={() => setMenuOpen(false)} to="/contact">Contact</NavLink>

                </nav>

                {/* DESKTOP NAV */}
                <nav className="nav-links">
                    <NavLink to="/">Home</NavLink>
                    <NavLink to="/about">About</NavLink>
                    <NavLink to="/services">Services</NavLink>
                    <NavLink to="/contact">Contact</NavLink>
                </nav>

            </div>
        </header>
    );
}

export default Navbar;